// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__v780K","row":"Node_row__3Gt2S","label":"Node_label__1lxjF","footer":"Node_footer__dKSN0"};